<section class="content-section">
  <!-- En-tête -->
  <div class="section-header" style="margin-bottom: 32px;">
    <div>
      <h2 style="font-size: 28px; font-weight: 700; color: var(--text-primary); margin-bottom: 8px;">
        Mes Commandes
      </h2>
      <p style="color: var(--text-secondary); font-size: 15px;">
        Commandes qui vous ont été assignées{{ nomLivreur ? ' — ' + nomLivreur : '' }}
      </p>
    </div>
    <button class="btn btn-secondary" type="button" (click)="chargerCommandes()">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
           stroke="currentColor" stroke-width="2" width="16" height="16">
        <polyline points="23 4 23 10 17 10"></polyline>
        <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"></path>
      </svg>
      Actualiser
    </button>
  </div>

  <div *ngIf="nombreAvis > 0 || moyenneNotes !== null" class="livreur-notes-banner">
    <div>
      <strong>Vos notes clients</strong>
      <span *ngIf="moyenneNotes !== null" class="moyenne">Moyenne : {{ moyenneNotes | number:'1.1-1' }} / 5</span>
      <span class="count">({{ nombreAvis }} avis)</span>
    </div>
    <ul class="mini-avis" *ngIf="avisRecents.length">
      <li *ngFor="let a of avisRecents">
        <span class="mono">{{ a.numeroCommande }}</span> — {{ a.note }}/5
        <span *ngIf="a.commentaire" class="com">« {{ a.commentaire }} »</span>
      </li>
    </ul>
  </div>

  <!-- Erreur -->
  <div *ngIf="messageErreur" class="error-banner">
    <span>⚠️</span>
    <span>{{ messageErreur }}</span>
  </div>

  <!-- Filtres -->
  <div class="filters-card">
    <div class="search-box">
      <svg class="search-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
           fill="none" stroke="currentColor" stroke-width="2">
        <circle cx="11" cy="11" r="8"></circle>
        <path d="m21 21-4.35-4.35"></path>
      </svg>
      <input type="text" class="search-input"
             placeholder="Rechercher par numéro, client ou statut..."
             [(ngModel)]="termeRecherche"
             (ngModelChange)="appliquerFiltres()">
    </div>
    <div class="status-filters">
      <button class="status-btn" [class.active]="statutSelectionne === 'all'"
              (click)="statutSelectionne = 'all'; appliquerFiltres()">
        Toutes ({{ commandes.length }})
      </button>
      <button class="status-btn" [class.active]="statutSelectionne === 'AFFECTE'"
              (click)="statutSelectionne = 'AFFECTE'; appliquerFiltres()">
        Livreur assigné ({{ compterParStatut('AFFECTE') }})
      </button>
      <button class="status-btn" [class.active]="statutSelectionne === 'EN_LIVRAISON'"
              (click)="statutSelectionne = 'EN_LIVRAISON'; appliquerFiltres()">
        Colis en route ({{ compterParStatut('EN_LIVRAISON') }})
      </button>
      <button class="status-btn" [class.active]="statutSelectionne === 'LIVRE'"
              (click)="statutSelectionne = 'LIVRE'; appliquerFiltres()">
        Livrées ({{ compterParStatut('LIVRE') }})
      </button>
    </div>
  </div>

  <!-- Chargement -->
  <div *ngIf="indicateurChargement" class="loading-container">
    <div class="spinner"></div>
    <p>Chargement de vos commandes...</p>
  </div>

  <!-- Tableau -->
  <div *ngIf="!indicateurChargement && commandesFiltrees.length > 0" class="table-card">
    <table class="commandes-table">
      <thead>
        <tr>
          <th>Numéro</th>
          <th>Client</th>
          <th>Type d'Envoi</th>
          <th>Transport</th>
          <th>Statut</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let commande of commandesFiltrees">
          <td class="number-cell"><strong>{{ commande.numeroCommande }}</strong></td>
          <td>{{ commande.clientNom || '-' }}</td>
          <td>{{ commande.typeEnvoi || '-' }}</td>
          <td>{{ commande.moyenTransport || '-' }}</td>
          <td>
            <span class="status-badge" [ngClass]="obtenirClasseBadgeStatut(commande.statut)">
              {{ obtenirTexteStatut(commande.statut) }}
            </span>
          </td>
          <td>
            <div style="display: flex; gap: 8px; align-items: center;">
              <!-- Bouton Voir les détails -->
              <button type="button" class="btn-icon-action"
                      matTooltip="Voir les détails et modifier le statut"
                      (click)="voirDetails(commande)"
                      style="background:none; border:none; padding:6px; cursor:pointer;
                             display:inline-flex; align-items:center; color:#00BFA5;">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                     fill="none" stroke="currentColor" stroke-width="2" width="20" height="20">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                  <circle cx="12" cy="12" r="3"></circle>
                </svg>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Aucun résultat -->
  <div *ngIf="!indicateurChargement && commandesFiltrees.length === 0 && !messageErreur"
       class="no-results">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
         fill="none" stroke="currentColor" stroke-width="2">
      <circle cx="12" cy="12" r="10"></circle>
      <line x1="12" y1="8" x2="12" y2="12"></line>
      <line x1="12" y1="16" x2="12.01" y2="16"></line>
    </svg>
    <h3>Aucune commande assignée</h3>
    <p>Vous n'avez aucune commande correspondant aux filtres sélectionnés.</p>
  </div>
</section>
